module.exports = __webpack_public_path__ + "static/media/arrow-slider-right-grey.2375d422.svg";